import bbox from "@turf/bbox";
import { FeatureCollection } from "@turf/helpers";
import mapboxgl, { Map, PaddingOptions } from "mapbox-gl";
import { parseGeoData } from "senf-shared";

interface Geometry {
  coordinates: number[][][];
  type: string;
}
interface Feature {
  id: string;
  type: string;
  properties: any;
  geometry: Geometry;
}
interface GeoData {
  type: string;
  features: Feature[];
}

function sanitizeFeatures(mapbounds: GeoData) {
  // Filter out features with null coordinates
  const features = mapbounds?.features?.filter(
    (feature) => feature.geometry.coordinates[0][0] !== null
  );

  // Create a new FeatureCollection with the sanitized features
  const sanitizedData = {
    type: "FeatureCollection",
    features,
  };

  return sanitizedData;
}

export const flyToPolygon = (map, geoJson, duration = 0, padding = {}, maxZoom = 22) => {
  if (!map || !geoJson || !geoJson.features || geoJson.features.length === 0) {
    console.warn('Ungültige Eingabedaten für flyToPolygon');
    return;
  }

  try {
    const bounds = new mapboxgl.LngLatBounds();

    geoJson.features.forEach((feature) => {
      if (feature.geometry.type === 'Point') {
        bounds.extend(feature.geometry.coordinates);
      } else if (feature.geometry.type === 'LineString') {
        feature.geometry.coordinates.forEach((coord) => {
          bounds.extend(coord);
        });
      } else if (feature.geometry.type === 'Polygon') {
        feature.geometry.coordinates[0].forEach((coord) => {
          bounds.extend(coord);
        });
      } else if (feature.geometry.type === 'MultiPolygon') {
        feature.geometry.coordinates.forEach((polygon) => {
          polygon[0].forEach((coord) => {
            bounds.extend(coord);
          });
        });
      }
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds, {
        padding,
        maxZoom,
        duration,
      });
    } else {
      console.warn('Leere Begrenzungen in flyToPolygon');
    }
  } catch (error) {
    console.error('Fehler in flyToPolygon:', error);
  }
};
